"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelSettingsT = exports.ModelSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const leg_tweaks_settings_js_1 = require("../../../solarxr-protocol/rpc/settings/leg-tweaks-settings.js");
const model_ratios_js_1 = require("../../../solarxr-protocol/rpc/settings/model-ratios.js");
const model_toggles_js_1 = require("../../../solarxr-protocol/rpc/settings/model-toggles.js");
const skeleton_height_js_1 = require("../../../solarxr-protocol/rpc/settings/skeleton-height.js");
/**
 * Settings for the skeletal model.
 */
class ModelSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsModelSettings(bb, obj) {
        return (obj || new ModelSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsModelSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ModelSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    toggles(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new model_toggles_js_1.ModelToggles()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    ratios(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new model_ratios_js_1.ModelRatios()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    legTweaks(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new leg_tweaks_settings_js_1.LegTweaksSettings()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    skeletonHeight(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new skeleton_height_js_1.SkeletonHeight()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startModelSettings(builder) {
        builder.startObject(4);
    }
    static addToggles(builder, togglesOffset) {
        builder.addFieldOffset(0, togglesOffset, 0);
    }
    static addRatios(builder, ratiosOffset) {
        builder.addFieldOffset(1, ratiosOffset, 0);
    }
    static addLegTweaks(builder, legTweaksOffset) {
        builder.addFieldOffset(2, legTweaksOffset, 0);
    }
    static addSkeletonHeight(builder, skeletonHeightOffset) {
        builder.addFieldOffset(3, skeletonHeightOffset, 0);
    }
    static endModelSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new ModelSettingsT((this.toggles() !== null ? this.toggles().unpack() : null), (this.ratios() !== null ? this.ratios().unpack() : null), (this.legTweaks() !== null ? this.legTweaks().unpack() : null), (this.skeletonHeight() !== null ? this.skeletonHeight().unpack() : null));
    }
    unpackTo(_o) {
        _o.toggles = (this.toggles() !== null ? this.toggles().unpack() : null);
        _o.ratios = (this.ratios() !== null ? this.ratios().unpack() : null);
        _o.legTweaks = (this.legTweaks() !== null ? this.legTweaks().unpack() : null);
        _o.skeletonHeight = (this.skeletonHeight() !== null ? this.skeletonHeight().unpack() : null);
    }
}
exports.ModelSettings = ModelSettings;
class ModelSettingsT {
    constructor(toggles = null, ratios = null, legTweaks = null, skeletonHeight = null) {
        this.toggles = toggles;
        this.ratios = ratios;
        this.legTweaks = legTweaks;
        this.skeletonHeight = skeletonHeight;
    }
    pack(builder) {
        const toggles = (this.toggles !== null ? this.toggles.pack(builder) : 0);
        const ratios = (this.ratios !== null ? this.ratios.pack(builder) : 0);
        const legTweaks = (this.legTweaks !== null ? this.legTweaks.pack(builder) : 0);
        const skeletonHeight = (this.skeletonHeight !== null ? this.skeletonHeight.pack(builder) : 0);
        ModelSettings.startModelSettings(builder);
        ModelSettings.addToggles(builder, toggles);
        ModelSettings.addRatios(builder, ratios);
        ModelSettings.addLegTweaks(builder, legTweaks);
        ModelSettings.addSkeletonHeight(builder, skeletonHeight);
        return ModelSettings.endModelSettings(builder);
    }
}
exports.ModelSettingsT = ModelSettingsT;
